// src/components/OrganosGobierno.jsx
import React, { useState } from 'react';
import './OrganosGobierno.css';

const seccionesGobierno = [
  {
    titulo: 'Junta de Gobierno Local',
    bloques: [
      { etiqueta: 'Presidencia', miembros: ['Sonia María Gómez Fernández'] },
      { etiqueta: 'Vocales', miembros: ['Susana Gómez Vallejo', 'Alicia Fuentes Alía', 'Abraham Moreno Otero'] }
    ]
  },
  {
    titulo: 'Comisión de Cuentas',
    bloques: [
      { etiqueta: 'Presidencia', miembros: ['Sonia María Gómez Fernández'] },
      { etiqueta: 'Vocales', miembros: ['Susana Gómez Vallejo', 'Alicia Fuentes Alía', 'Jesús Fuentes Sánchez', 'José Luis Grau Moreno', 'Carlos Jiménez Jiménez', 'Marina Illescas Gutiérrez'] }
    ]
  },
  {
    titulo: 'Comisión Mixta Permanente',
    bloques: [
      { etiqueta: 'Presidencia', miembros: ['Sonia María Gómez Fernández'] },
      { etiqueta: 'Vocales', miembros: ['Susana Gómez Vallejo', 'Alicia Fuentes Alía', 'Jesús Fuentes Sánchez', 'José Luis Grau Moreno', 'Francisco Javier Del Moral González', 'Marina Illescas Gutiérrez'] }
    ]
  },
];

export default function OrganosGobierno () {
  const [open, setOpen] = useState(null);
  const toggle = idx => setOpen(open === idx ? null : idx);

  return (
    <section className="organos-gobierno">
      <div className="container">
        <h1>Órganos de Gobierno</h1>
        <p>Conoce la composición de cada órgano colegiado municipal.</p>

        {seccionesGobierno.map((sec, i) => (
          <article className="accordion" key={i}>
            <button className={`accordion-btn ${open===i?'open':''}`} onClick={()=>toggle(i)}>
              {sec.titulo}
              <span className="arrow">{open===i?'▲':'▼'}</span>
            </button>

            {open===i && (
              <div className="accordion-panel">
                {sec.bloques.map((b,j)=>(
                  <div className="bloque" key={j}>
                    <h3>{b.etiqueta}</h3>
                    <ul>{b.miembros.map((m,k)=><li key={k}>{m}</li>)}</ul>
                  </div>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
